// Куда вернуть человека после входа.
//
// Страница кабинета без сессии отправляет на /cabinet?lang=…&next=<откуда
// пришёл>; next едет в ссылке из письма до /auth/callback и оттуда — обратно.
// Принимается только путь внутри кабинета: адрес из строки запроса — чужие
// данные, и без проверки ссылка «войти» уводила бы на любой сайт.

const MAX = 512;

export function safeNext(v: unknown): string | null {
  if (typeof v !== "string" || !v || v.length > MAX) return null;
  // Только свой путь: с одного «/», без «//» и «\» (протокол-относительные
  // адреса), без схемы и управляющих символов.
  if (!v.startsWith("/") || v.startsWith("//") || v.includes("\\") || /[\u0000-\u001f]/.test(v)) return null;
  const path = v.split(/[?#]/)[0];
  if (path !== "/cabinet" && !path.startsWith("/cabinet/")) return null;
  return v;
}

/** Адрес входа для страницы кабинета без сессии: язык и путь возврата. */
export function loginRedirect(): { to: "/cabinet"; search: { lang?: "ru" | "az" | "en"; next?: string } } {
  if (typeof window === "undefined") return { to: "/cabinet", search: {} };
  const here = new URL(window.location.href);
  const l = here.searchParams.get("lang");
  const lang = l === "ru" || l === "az" || l === "en" ? l : undefined;
  const next = safeNext(here.pathname + here.search) ?? undefined;
  return { to: "/cabinet", search: { lang, next } };
}

/**
 * Возврат админа после входа (/auth?next=…): только путь внутри /admin —
 * ссылка из письма «Правка анкеты» ведёт на /admin/review/<id> (24.10.2026).
 */
export function safeAdminNext(v: unknown): string | null {
  if (typeof v !== "string" || !v || v.length > MAX) return null;
  if (!v.startsWith("/") || v.startsWith("//") || v.includes("\\") || /[\u0000-\u001f]/.test(v)) return null;
  const path = v.split(/[?#]/)[0];
  if (path !== "/admin" && !path.startsWith("/admin/")) return null;
  return v;
}
